import { render, staticRenderFns } from "./ForceSyncBCModal.vue?vue&type=template&id=5ced59b8&"
import script from "./ForceSyncBCModal.vue?vue&type=script&lang=js&"
export * from "./ForceSyncBCModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports